<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/g1UN2a/media/FC-9798886939323.jpg?1697494221421" alt="This image is the cover for the book The Pause"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Pause
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Arial Nova",sans-serif;'>This collection of poems takes us through life experiences to which we can all relate. The themes of unrequited love, heartache after heartbreak, experiencing loss, getting caught in the rat race, facing the struggle of keeping up with the pace of a heavy workload, dealing with issues of racism, addiction, and discrimination. It also explores feelings concerning the impact of the recent COVID-19 Pandemic which increased many of our feelings of isolation, desperation, and has caught us off guard while trying to come to terms with the unknowns. There are other themes of police brutality as referenced in the George Floyd Incident and as captured in “Let’s be clear.”</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Arial Nova",sans-serif;'>Throughout all this, one still has hope for the future, and that one’s children will be able to cope as they try to navigate life and its day-to-day challenges.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christiana Brontie
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0cm;font-size:16px;font-family:"Courier New";color:black;'><br></p><p style='margin:0cm;font-size:16px;font-family:"Courier New";color:black;'><br></p><p style='margin:0cm;font-size:16px;font-family:"Courier New";color:black;text-align:justify;'><span style='font-size:15px;font-family:"Times New Roman",serif;color:windowtext;'>Christiana Brontie was born and raised in Brontie District in Manchester, Jamaica. She is the mother of two daughters. After migrating to Canada in 1983, she obtained a bachelor of social work degree and now works as a child protection worker.</span></p><p style='margin:0cm;font-size:16px;font-family:"Courier New";color:black;text-align:justify;'><br></p><p style='margin:0cm;font-size:16px;font-family:"Courier New";color:black;text-align:justify;'><span style='font-size:15px;font-family:"Times New Roman",serif;color:windowtext;'>She is the second of four children who were raised by a single mother. As a child she was an extrovert who was very outgoing. As she grew older and experienced the harsh realities of life, she became more reserved, quiet, and introverted, while taking on the role of a follower instead of the role of a leader, as demonstrated in the pre-pubertal stage.</span></p><p style='margin:0cm;font-size:16px;font-family:"Courier New";color:black;text-align:justify;'><br></p><p style='margin:0cm;font-size:16px;font-family:"Courier New";color:black;text-align:justify;'><span style='font-size:15px;font-family:"Times New Roman",serif;color:windowtext;'>She has always been a thinker who loves deeply and still yearns of having this feeling reciprocated.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?43ce490a